import axios from 'axios';
import { getItem } from 'helpers/localStorage';
import { logout, saveTokens } from 'store/login/loginOperations';
import store from 'store/store';

let pending = null;

export const refreshSession = (failedToken) => {
  const token = getItem('authorization-token');
  if (!token) return Promise.reject(new Error('Signed out'));
  if (token !== failedToken) return Promise.resolve(token); // already refreshed by another tab or request

  if (!pending) {
    pending = axios
      .post(`${process.env.REACT_APP_BASE_URL}/refresh-token`, { refreshToken: getItem('refresh-token') })
      .then(({ data }) => {
        if (!getItem('authorization-token')) throw new Error('Signed out'); // don't resurrect a session ended mid-refresh
        saveTokens(data);
        return data.token;
      })
      .catch((err) => {
        if ([400, 401].includes(err.response?.status)) store.dispatch(logout());
        throw err;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
};
